/** @import modules */

import { useQuery }         from "@apollo/client";

import { useContext }       from "react";

/** @import contexts */

import { CartContext }      from "../Contexts/CartContext";

/** @import queries */

import { CartSummary }      from "../Queries/Orders";

/**
 * 
 * @param { String } location - City name (default: "Riga")
 * @param { String } country - Country code (default: "LV")
 * 
 * @returns Cart items collection model
 * 
 * @note For cart loading, we don't need delivery plan - backend uses fallback deliveryPrice (0)
 * 
 */

const OrderSummary = ( location = "Riga", country = "LV" ) => { const

    { cart } = useContext ( CartContext ),

    // Filter out invalid cart items (must have id and qty)
    validCartItems = ( cart || [] ).filter ( item => 
        item && 
        item.id && 
        ( item.qty !== undefined && item.qty !== null && item.qty > 0 )
    ),

    { loading, data, error, refetch } = useQuery ( CartSummary, { 
        
        variables: { 
        
            productParams: validCartItems.length > 0 ? validCartItems : [], 
            
            city: location || "Riga", 
            
            countryCode: country || "LV", 
            
            deliveryPrice: 0,

            servicePrice: 0,

            vat: true
        
        },
        
        skip: !validCartItems || validCartItems.length === 0,
        
        errorPolicy: "all",
        
        onError: ( error ) => {
            console.error ( "[OrderSummary] Query error:", error );
            console.error ( "[OrderSummary] Cart items:", cart );
            console.error ( "[OrderSummary] Valid cart items:", validCartItems );
        }
    
    } )

    /** Return model */

    return { loading, data, error, refetch }

}

/** Export model */

export default OrderSummary;